class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.hoverCloseTimeout = null;
    this.mql = window.matchMedia('(min-width: 990px)');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.bindNestedDetails();
    this.bindHoverBehavior();
  }

  get hoverEnabled() {
    return this.mql.matches;
  }

  bindHoverBehavior() {
    this.addEventListener('mouseenter', this.onHoverEnter.bind(this));
    this.addEventListener('mouseleave', this.onHoverLeave.bind(this));

    const summary = this.mainDetailsToggle.querySelector('summary');
    summary.addEventListener('click', (event) => {
      // Op desktop opent hover al; klik mag een open menu niet meteen dichtdoen.
      if (this.hoverEnabled && this.mainDetailsToggle.open) {
        event.preventDefault();
      }
    });
  }

  bindNestedDetails() {
    this.querySelectorAll('.header__submenu details').forEach((details) => {
      details.addEventListener('toggle', () => this.onNestedToggle(details));

      details.addEventListener('mouseenter', () => {
        if (!this.hoverEnabled) return;
        this.clearHoverClose();
        details.setAttribute('open', '');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        this.onNestedToggle(details);
      });

      details.addEventListener('mouseleave', () => {
        if (!this.hoverEnabled) return;
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      });

      details.querySelector('summary')?.addEventListener('click', (event) => {
        if (this.hoverEnabled && details.open) {
          event.preventDefault();
        }
      });
    });
  }

  onHoverEnter() {
    if (!this.hoverEnabled) return;
    this.clearHoverClose();
    this.open();
  }

  onHoverLeave() {
    if (!this.hoverEnabled) return;
    this.scheduleHoverClose();
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  scheduleHoverClose() {
    this.clearHoverClose();
    this.hoverCloseTimeout = setTimeout(() => this.close(), 120);
  }

  clearHoverClose() {
    if (!this.hoverCloseTimeout) return;
    clearTimeout(this.hoverCloseTimeout);
    this.hoverCloseTimeout = null;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.closeSiblingDisclosures();
      this.animations.forEach((animation) => animation.play());
    } else {
      this.closeNestedDetails();
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  onNestedToggle(details) {
    if (!details.open) return;

    const parentItem = details.parentElement;
    const parentList = parentItem && parentItem.parentElement;
    if (!parentList) return;

    Array.from(parentList.children).forEach((listItem) => {
      const sibling = listItem.querySelector('details');
      if (sibling && sibling !== details && sibling.open) {
        sibling.removeAttribute('open');
        sibling.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    });
  }

  closeSiblingDisclosures() {
    document.querySelectorAll('header details-disclosure').forEach((disclosure) => {
      if (disclosure !== this) disclosure.close();
    });
  }

  closeNestedDetails() {
    this.querySelectorAll('.header__submenu details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  close() {
    this.clearHoverClose();
    this.closeNestedDetails();
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
